import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id FA914D65-0F2C-463D-A54F-9B0DE9FBEED3
 * name credit-card-plus-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-plus-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardPlusOutlineIcon = createSvgIcon(<><path d="M21,18H24V20H21V23H19V20H16V18H19V15H21V18M19,8V6H3V8H19M19,12H3V18H14V20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H19A2,2 0 0,1 21,6V13H19V12Z" /></>, 'CreditCardPlusOutlineIcon');
export default CreditCardPlusOutlineIcon